import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";

// users
import user1 from "../../../assets/images/users/user-4.jpg";

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);

  const [username, setusername] = useState("Admin");
  const [avatar, setavatar] = useState(user1);

  // Define the function!
  function updateProfileMenu() {
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "pocketbase") {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj.record.name);
        if (obj.record.avatar && obj.record.avatar !== "") {
          // Construct the avatar URL using the PocketBase API
          const src = process.env.REACT_APP_PB_URL + "/api/files/users/" + obj.record.id + "/" + obj.record.avatar;
          setavatar(src);
        } else {
          // Set a default avatar if none exists
          setavatar(require("../../../assets/images/users/avatar-6.jpg"));
        }
      }
    }
  }

  useEffect(() => {
    updateProfileMenu(); // initial load

    window.addEventListener("authUserUpdated", updateProfileMenu);
    return () => window.removeEventListener("authUserUpdated", updateProfileMenu);
  }, [props.success]);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={avatar}
            alt="Header Avatar"
          />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem tag={Link} to="/profile">
            <i className="mdi mdi-account-circle font-size-17 align-middle me-1" />
            {props.t("Profile")}
          </DropdownItem>
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item text-danger">
            <i className="bx bx-power-off font-size-17 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
